<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput :option="{placeholder:'版本名称',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;param.isshow=true;}
                        if(val.type=='keydown') GetLevel();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetLevel()" />
            </el-form-item>
            <el-form-item>  
                <wcbutton :option="{title:'新增账号'}" @finish="AddLevel()" />
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" id="table-platlevel-obj">
        <el-table :data="levellist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="版本id" prop="id" align="center" />
            <el-table-column label="版本名称" prop="levelname" align="center" />
            <el-table-column label="使用账号数量" prop="shopnums" align="center" />
            <el-table-column label="添加时间" prop="inputtime" align="center" />
            <el-table-column label="备注" prop="note" align="center" />
            <el-table-column label="操作" align="center" fixed="right" min-width="180">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="EditLevel(scope.row.id)" />
                    <wcbutton :option="{title:'设置权限'}" @finish="SetLevelAuth(scope.row)" class="left10"/>
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DelLevel(scope.row.id)" class="left10"/>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <el-select v-model="handlevalue" placeholder="请选择操作" clearable @change="changehandle">
                    <el-option v-for="(item,index) in handleinfos" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetLevel();
                    }"
                />
            </div>
        </div>
    </div>

</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
export default {
    components:{},
    data() {
        return {
            param: {
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0,
            },
            levellist:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除账号'},
                {id:2,name:'批量编辑账号'},
            ],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetLevel();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.GetLevel();
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.GetPlatForm();
            }else {
                this.GetLevel();
            }
        },


        /** 数据批操作处理 **/
        changehandle(index) {
            this.handlevalue='';
            var ids=this.GetSelectDataIds();
            if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的版本',type:'warning'});return false;}
            ids=ids.join(',');

            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                if(index==1) {
                    this.DelLevelMore(ids);
                }else if(index==2) {
                    this.EditLevelMore(ids);
                }
               
            }).catch(()=> {
                
            });
        },


        /** 删除账号信息 **/
        DelLevel(id) {
            this.$confirm.confirm(
                '您是否确定要删除当前版本 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.DelLevelMore(id);
            }).catch(()=> {
                
            });
        },


        /** 删除账号信息操作 **/
        DelLevelMore(ids) {
            INTERFACE_MODEL_SHOP.DEL_SHOP_LEVEL({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetLevel();
            });
        },


        /** 编辑账号信息 **/
        EditLevel(id) {
            this.EditLevelMore(id);
        },


        /** 编辑版本权限信息 **/
        SetLevelAuth(row) {
            if (!row || !row.id) return;
            this.$parent.JUMPVIEW({
                name: 'SetPlatFormLevelAuth',
                param: { id: row.id, levelname: row.levelname || '' },
            });
        },

        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        //基础数据操作

        /** 获取平台账号inxi **/
        GetLevel() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-platlevel-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_SHOP.GET_PLATFORM_Level(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.levellist=res.data.list;
            });
        },


        /** 新增管理员信息 **/
        AddLevel() {
            var navinfo={name:'新增版本',labelentry:'AddPlatFormLevel',components:'AddPlatFormLevel',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑管理员信息 **/
        EditLevelMore(ids) {
            var navinfo={name:'编辑平台账号版本',labelentry:'EditPlatFormLevel',components:'EditPlatFormLevel',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.levellist.length;i++) this.levellist[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.levellist);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.levellist.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },

        //基础数据操作
        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-image {position: relative;display: inline-block;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-image-box-small {border-radius: 50%;}
.TTL-isadmin {
    position:absolute;
    bottom:0;
    right:0;
    margin-right:-5px;
    width:25px;
    height:25px;
    border-radius: 50%;
    background-color: #ffffff;
    background-image:url(@/assets/icon/isplatform.png);
    background-repeat: no-repeat;
    background-size: 14px;
    background-position: center;
}
.TTL-names {font-weight: 550;letter-spacing: 1px;display: inline-block;width:100%}
.TTL-names i {font-style: normal;color: #999999;zoom:.9;font-weight: 500;font-size:12px;}
.TTL-desc {display:inline-block;width:100%;font-size:12px;color:#999999;}
.TTL-btn-list {display:inline-flex;}
</style>